import { render, staticRenderFns } from "./JobConversation.vue?vue&type=template&id=5fba6f50"
import script from "./JobConversation.vue?vue&type=script&lang=js"
export * from "./JobConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports